export const TOUR_ONBOARDING_STEP_COUNT_KEY = 'tourOnboardingStepCount';
export const TOUR_ONBOARDING_FLAG = 'showTourOnboarding';
export const TOUR_ONBOARDING_MASTERY_LEVEL_FLAG = 'showOnboardingMasteryLevel';
export const TOUR_ONBOARDING_BUBBLE_ECONOMY_FLAG =
  'showOnboardingBubbleEconomy';
export const STATE_ONBOARDING_TOOLTIP_NOT_FINISHED = 0;
export const STATE_ONBOARDING_TOOLTIP_FINISHED = 1;
export const STATE_ONBOARDING_MASTERY_LEVEL_FINISHED = 2;
export const STATE_ONBOARDING_BUBBLE_ECONOMY_FINISHED = 1;

export const POPUP_SKILL_LEVEL_PRIMARY_STUDENTS_KEY =
  'showPopupSkillLevelPrimaryStudents';
export const SKILL_LEVEL_POPUP_ACTION = {
  VIEW_PROGRESS: 1,
  DISMISS: 2,
};
